import styled, { css } from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isActive?: boolean
}

export const Step = styled.li<Props>`
	display: grid;
	grid-template-columns: 32px minmax(0, 1fr);
	column-gap: 16px;
	position: relative;
	color: ${({ isActive, theme }) => (isActive ? theme.color.text : helpers.color.disabled)};

	& + & {
		margin-top: 72px;
	}

	${({ isActive }) =>
		isActive &&
		css`
		&:after {
			content: '';
			position: absolute;
			left: 16px;
			top: 42px;
			bottom: -62px;
			border-left: 1px dashed ${helpers.color.text};
		}
	`}
`
